/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const file_warning = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.59 3.5 8.618 1.328A1 1 0 0 0 7.878 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1m7.5-4.063v-2m0 4.195h.022m4.337 0a1.258 1.258 0 0 1-.058 1.256 1.314 1.314 0 0 1-.484.449 1.363 1.363 0 0 1-.648.163H7.331a1.37 1.37 0 0 1-.649-.163 1.313 1.313 0 0 1-.484-.449 1.262 1.262 0 0 1-.057-1.256L9.31 6.94c.11-.214.28-.395.49-.52a1.361 1.361 0 0 1 1.4 0c.21.125.38.306.49.52l3.17 6.193Z"
    />
  </svg>
)
export default file_warning
